export const LINEAR_ASKS_OPTIONS = [
	{ value: "mark_done", label: "Mark done" },
	{
		value: "mark_done_and_close_loop",
		label: "Mark done and send close-loop reply",
	},
	{ value: "link_only", label: "Only link" },
] as const

export type LinearAsksModeValue = (typeof LINEAR_ASKS_OPTIONS)[number]["value"]

/** An unknown stored value reads as the default, the way the server treats it. */
export function linearAsksModeValue(
	value: string | null | undefined,
): LinearAsksModeValue {
	return (
		LINEAR_ASKS_OPTIONS.find((option) => option.value === value)?.value ??
		"mark_done"
	)
}
